import 'styles/main.scss'
import 'utils/loadAsyncSVG'
import React from 'react'
import { Script } from 'gatsby'
import { GIT_VERSION } from 'gatsby-env-variables'
import isClient from 'utils/isClient'
import { isSourceOrigin } from 'utils/isSourceOrigin.js'
import { LoaderProvider } from 'hooks/useLoader'

import initMake from '@mobi/libraries/analytics/make/setup'
import { StepsProvider } from 'hooks/useSteps.js'
import { ThemeProvider } from 'modules/Theme'
import { NotifyProvider } from 'modules/Notify.js'

if (isClient()) {
  window.__VERSION__ = GIT_VERSION
}

Promise.resolve(
  import(
    /* webpackChunkName: "thirdPartyScripts" */ './utils/thirdPartyScripts.js'
  )
)

function wrapElement({ element }) {
  if (!isSourceOrigin('pivo')) {
    initMake()
  }

  return (
    <ThemeProvider>
      <LoaderProvider>
        <StepsProvider>
          <NotifyProvider>{element}</NotifyProvider>
        </StepsProvider>
      </LoaderProvider>

      <Script>
        {`;(function(){window.dataLayer.push({"event":"optimize.activate"})})();`}
      </Script>
    </ThemeProvider>
  )
}

export default wrapElement
